import './index.scss';
import { PropType, VNode, defineComponent, h, toRaw } from 'vue';
import { Option } from '@vaaas/fpts/option';
import { isEnterOrSpace, isEscape } from '@frontend/keyboard';

type Item<T> = {
    value: T;
    node: VNode | VNode[];
}

export default <T>() => defineComponent({
    props: {
        items: {
            required: true,
            type: Array as PropType<Item<T>[]>,
        },

        value: {
            required: true,
            type: null as any as PropType<Option<T>>,
        },
    },

    emits: {
        'update:value': (x: Option<T>) => true,
        bottom: () => true,
    },

    methods: {
        last_item(): Option<HTMLDivElement> {
            return this.$el.lastElementChild;
        },

        handle_intersection(xs: IntersectionObserverEntry[]) {
            if (xs.some(x => x.isIntersecting))
                this.$emit('bottom');
        },
    },

    data() {
        return {
            observer: undefined as Option<IntersectionObserver>,
        };
    },

    mounted() {
        this.observer = new IntersectionObserver(this.handle_intersection);
        const last_item = this.last_item();
        if (last_item)
            this.observer.observe(last_item);
    },

    updated() {
        this.observer?.disconnect();
        const last_item = this.last_item();
        if (last_item)
            this.observer?.observe(last_item);
    },

    render() {
        return h('div', { class: 'list-group-select' },
            this.items.map((x, i) => h('article', {
                key: i,
                class: {
                    'list-group-select-item': true,
                    active: toRaw(x.value) === toRaw(this.value),
                },
                tabIndex: '0',
                onClick: () => this.$emit('update:value', x.value),
                onKeydown: (e: KeyboardEvent) => {
                    if (isEnterOrSpace(e))
                        this.$emit('update:value', x.value);
                    else if (isEscape(e) && toRaw(x) === toRaw(this.value))
                        this.$emit('update:value', undefined);
                },
            }, x.node))
        );
    },
});
